// src/pages/admin/ProtectedRoute.jsx

import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminLoggedIn } from "./auth";

const ProtectedRoute = ({ children }) => {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/admin-control-panel/admin-login" replace />;
  }
  return children;
};

export default ProtectedRoute;